import PropTypes from 'prop-types';

import { clsx } from '../../utils/clsx';
import { LinkPreviewCard } from '../LinkPreviewCard';
import styles from './LinkPreviewList.module.css';

const LinkPreviewList = ({
  previews = [],
  loading = false,
  loadingMessage = 'Fetching link preview…',
  error = false,
  errorMessage = "We couldn’t load one of the links. Please verify the URL.",
  onRemove,
  size = 'default',
  className,
  messageClassName,
}) => {
  const shouldRender = previews.length > 0 || loading || error;

  if (!shouldRender) {
    return null;
  }

  return (
    <div className={clsx(styles.list, styles[`listSize-${size}`], className)}>
      {previews.map((preview) => (
        <LinkPreviewCard
          key={preview.url}
          {...preview}
          size={size}
          onRemove={onRemove ? () => onRemove(preview.url) : undefined}
        />
      ))}
      {loading ? (
        <div className={clsx(styles.message, messageClassName)}>{loadingMessage}</div>
      ) : null}
      {error ? (
        <div className={clsx(styles.message, styles.messageError, messageClassName)}>
          {errorMessage}
        </div>
      ) : null}
    </div>
  );
};

LinkPreviewList.propTypes = {
  previews: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      siteName: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      imageUrl: PropTypes.string,
    }),
  ),
  loading: PropTypes.bool,
  loadingMessage: PropTypes.string,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  onRemove: PropTypes.func,
  size: PropTypes.oneOf(['default', 'compact']),
  className: PropTypes.string,
  messageClassName: PropTypes.string,
};

export default LinkPreviewList;
